var state = {
  network_recover_trigger: false,
  // 网络刷新触发器
  owner: '',
  isInnerNetwork: false,
  // 是否为内网
  network_online: true,
  // 网络在离线
  poorNetwork: false // 是否为弱网

};
var mutations = {
  // 网络恢复，通知页面刷新，
  NETWORK_RECOVER_TRIGGER: function NETWORK_RECOVER_TRIGGER(state, owner) {
    state.network_recover_trigger = !state.network_recover_trigger;
    state.owner = owner;
  },
  UPDATE_NETWORK_STATUS: function UPDATE_NETWORK_STATUS(state, value) {
    state.isInnerNetwork = value;
  },
  UPDATE_ONLINE_STATUS: function UPDATE_ONLINE_STATUS(state, value) {
    state.network_online = value;
  },
  UPDATE_POOR_NETWORK_STATUS: function UPDATE_POOR_NETWORK_STATUS(state, value) {
    state.poorNetwork = value;
  }
};
var actions = {
  updateNetwork: function updateNetwork(_ref, value) {
    var commit = _ref.commit;
    commit('UPDATE_NETWORK_STATUS', value);
  },
  updateOnlineStatus: function updateOnlineStatus(_ref2, value) {
    var commit = _ref2.commit;
    commit('UPDATE_ONLINE_STATUS', value);
  },
  updatePoorNetworkStatus: function updatePoorNetworkStatus(_ref3, value) {
    var commit = _ref3.commit;
    commit('UPDATE_POOR_NETWORK_STATUS', value);
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};